module.exports = __webpack_public_path__ + "static/media/time_in_nicu.364aa9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/time_in_nicu.png
// module id = 1483
// module chunks = 31